module.exports = __webpack_public_path__ + "static/media/map_mit_grabbi.23006545.png";